// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';
import Timer from '../common/Timer';

import makeTimerPeriodIdPropsSelector from './TimerPeriodId.selector';

type TimerPeriodIdContainerProps = {
  className?: string;
  matchId: number;
  isGrid?: boolean;
};

const TimerPeriodIdContainer = ({ matchId, isGrid, ...ownProps }: TimerPeriodIdContainerProps) => {
  const selector = useMemo(() => makeTimerPeriodIdPropsSelector(), []);
  const selectorProps = useMemo(() => ({ matchId, isGrid }), [matchId, isGrid]);
  const selectedProps = useSelector((state) => selector(state, selectorProps));
  const { type, seconds } = selectedProps;

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  if (type && seconds !== undefined) {
    return <Timer {...enhancedProps} />;
  }

  return null;
};

export default TimerPeriodIdContainer;
